<template>
  <BlockFieldset class="project-customer-master-data">
    <b-row>
      <b-col lg="6" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('salutation')"
          label-for="salutation"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="invalidFeedbackNA"
          :state="requirementState('salutation')"
        >
          <multiselect
            v-model="project.customer.salutation"
            id="salutation"
            :disabled="isBlockReadOnly"
            :options="getEnumValues('Salutation')"
            :placeholder="$t('select_salutation')"
            :allow-empty="false"
            :show-labels="false"
            deselectLabel
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">{{ $t(option) }}</template>
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('company')"
          label-for="company"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input
            v-model="project.customer.company"
            type="text"
            :placeholder="$t('company')"
          />
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('firstname')"
          label-for="firstname"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="invalidFeedbackNA"
          :state="requirementState('firstname')"
        >
          <b-form-input
            :state="requirementState('firstname')"
            v-model="project.customer.firstname"
            type="text"
            :placeholder="$t('firstname')"
          />
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('lastname')"
          label-for="lastname"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="invalidFeedbackNA"
          :state="requirementState('lastname')"
        >
          <b-form-input
            v-model="project.customer.lastname"
            type="text"
            :placeholder="$t('lastname')"
            :state="requirementState('lastname')"
          />
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('street')"
          label-for="street"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="invalidFeedbackNA"
          :state="requirementState('street')"
        >
          <b-form-input
            v-model="project.customer.street"
            type="text"
            :placeholder="$t('street')"
            :state="requirementState('street')"
          />
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('streetNumber')"
          label-for="streetNumber"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input
            v-model="project.customer.streetNumber"
            type="text"
            :placeholder="$t('streetNumber')"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('streetNumberSuffix')"
          label-for="streetNumberSuffix"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input
            v-model="project.customer.streetNumberSuffix"
            type="text"
            :placeholder="$t('streetNumberSuffix')"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('zip')"
          label-for="zip"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="invalidFeedbackNA"
          :state="requirementState('zip')"
        >
          <b-form-input
            v-model="project.customer.zip"
            type="text"
            :placeholder="$t('zip')"
            :state="requirementState('zip')"
          />
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('city')"
          label-for="city"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="invalidFeedbackNA"
          :state="requirementState('city')"
        >
          <b-form-input
            v-model="project.customer.city"
            type="text"
            :placeholder="$t('city')"
            :state="requirementState('city')"
          />
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('cityPart')"
          label-for="cityPart"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input
            v-model="project.customer.cityPart"
            type="text"
            :placeholder="$t('cityPart')"
          />
        </b-form-group>
      </b-col>

      <b-col lg="6" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('phone')"
          label-for="phone"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="invalidFeedbackNA"
          :state="requirementState('phone')"
        >
          <b-form-input
            v-model="project.customer.phone"
            type="text"
            :placeholder="$t('phone')"
            :state="requirementState('phone')"
          />
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('phone2')"
          label-for="phone2"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input
            v-model="project.customer.phone2"
            type="text"
            :placeholder="$t('phone2')"
          />
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('phone3')"
          label-for="phone3"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input
            v-model="project.customer.phone3"
            type="text"
            :placeholder="$t('phone3')"
          />
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('mobile')"
          label-for="mobile"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input
            v-model="project.customer.mobile"
            type="text"
            :placeholder="$t('mobile')"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('mobile2')"
          label-for="mobile2"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input
            v-model="project.customer.mobile2"
            type="text"
            :placeholder="$t('mobile2')"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('email')"
          label-for="email"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="emailInvalidFeedback"
          :state="emailFieldState"
        >
          <b-form-input
            v-model="project.customer.email"
            type="text"
            :placeholder="$t('email')"
            :state="emailFieldState"
          />
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('email2')"
          label-for="email2"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="$t('customer_master_data_email_invalid')"
          :state="email2FieldState"
        >
          <b-form-input
            v-model="project.customer.email2"
            type="text"
            :placeholder="$t('email2')"
            :state="email2FieldState"
          />
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('birthdayAt')"
          label-for="birthdayAt"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <Calendar
            v-model="birthdayAt"
            :disabled="isBlockReadOnly"
            selectionMode="single"
            dateFormat="dd.mm.yy"
            :placeholder="$t('date')"
            :showWeek="true"
            :yearNavigator="true"
            :monthNavigator="true"
            yearRange="1930:2021"
          >
          </Calendar>
        </b-form-group>
      </b-col>
    </b-row>

    <div v-if="hasSaveButton" class="text-right mt-2">
      <b-button variant="bg" :disabled="isSaving || !areEmailsValid" @click="save">
        {{ $t('saveNamed', { name: $t('project_customer_master_data') }) }}
      </b-button>
    </div>
  </BlockFieldset>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Calendar from 'primevue/calendar';
import Multiselect from 'vue-multiselect';
import BlockFieldset from '@/components/Access/BlockFieldset.vue';
import { AccessBlockMixin } from '@/mixins/accessBlock';
import { BlockSaveMixin } from '@/mixins/blockSave';
import { isRequirementFulfilled } from '@/helpers/registrationRequirements';
import {
  isValidCustomerMasterDataEmail,
  toProjectCustomerMasterDataInput,
} from './projectCustomerMasterDataInput';

/** Number of the unsaved project (ProjectEdit `_new`): its values go with `createProject`. */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Block project-customer-master-data (plan docs/work/_done/2026-10-project-block-customer-master-data):
 * master-data fields on `customer`, requirement badges, email format check, own save button.
 * On the unsaved project it has no save button. Emits `dirty` and `saved`.
 */
export default {
  name: 'ProjectCustomerMasterData',
  components: { BlockFieldset, Calendar, Multiselect },
  mixins: [AccessBlockMixin, BlockSaveMixin],
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
  },
  computed: {
    ...mapGetters(['getEnumValues']),
    blockInput() {
      return toProjectCustomerMasterDataInput(this.project);
    },
    hasSaveButton() {
      return !this.isBlockReadOnly && this.project.number !== NEW_PROJECT_NUMBER;
    },
    invalidFeedbackNA() {
      return 'Voraussetzung NA';
    },
    areEmailsValid() {
      return (
        isValidCustomerMasterDataEmail(this.project.customer.email) &&
        isValidCustomerMasterDataEmail(this.project.customer.email2)
      );
    },
    emailFieldState() {
      if (!isValidCustomerMasterDataEmail(this.project.customer.email)) {
        return false;
      }

      return this.requirementState('email');
    },
    emailInvalidFeedback() {
      if (!isValidCustomerMasterDataEmail(this.project.customer.email)) {
        return this.$t('customer_master_data_email_invalid');
      }

      return this.invalidFeedbackNA;
    },
    email2FieldState() {
      if (!isValidCustomerMasterDataEmail(this.project.customer.email2)) {
        return false;
      }

      return null;
    },
    birthdayAt: {
      get() {
        return this.$calendarFormat(this.project.customer.birthdayAt);
      },
      set(value) {
        this.project.customer.birthdayAt = value;
      },
    },
  },
  methods: {
    ...mapActions(['updateProjectCustomerMasterData', 'fetchEnumValues']),
    saveBlockInput(input) {
      return this.updateProjectCustomerMasterData({ projectNumber: this.project.number, input });
    },
    requirementState(name) {
      return isRequirementFulfilled(this.project.netRegistrationRequirements, name);
    },
  },
  async mounted() {
    await this.fetchEnumValues('Salutation');
  },
};
</script>
